import { useContext } from "react";
import { ChannelsContext } from '../../../context/ChannelsContext';
import { usePreference } from "../../../context/usePreference";
import { IndiceContext } from "../../../context/IndiceContext";
export function ReportChartPie({
  audience,
  qtyMinutes,
}) {
  const RootComponent = document.getElementById("root");
  const { channels } = useContext(ChannelsContext);
  const { indice } = useContext(IndiceContext);
  const pUiScreenWidth = Math.max(0, parseFloat(RootComponent ? getComputedStyle(RootComponent).width : '0'));
  const pUiScreenHeight = Math.max(0, parseFloat(RootComponent ? getComputedStyle(RootComponent).height : '0'));
  const u = usePreference();

  const pRowsHeaders = audience != null && audience.length > 0 ? audience.map(row => row.slice(0, 4)) : [];
  const pRowsColumns = audience != null && audience.length > 0 ? audience[0].slice(4).map((_, i) => audience.map(row => row[i + 4] === '0' ? '-' : row[i + 4]).reverse()) : [];

  const chartTopPadding = 30;
  const qtdEmissoras = 9;

  const pChartHeight = (pUiScreenHeight - chartTopPadding - 140) / 2


  function enableTooltip(visibilityStatus, valueFromChart) {
    const divTooltip = document.getElementById("tooltip-pie")!;
    window.addEventListener('mousemove', function (event) {
      const x = event.clientX;
      const y = event.clientY;
      divTooltip.style.visibility = visibilityStatus;
      divTooltip.style.left = x + "px";
      divTooltip.style.top = y + "px";
      divTooltip.style.zIndex = "1";
      divTooltip.style.fontWeight = 'bold';
      divTooltip.style.fontSize = "10px";
      divTooltip.style.backgroundColor = '#f2f5f9';
      const chartValue = divTooltip.querySelectorAll("text");
      chartValue[0].innerHTML = valueFromChart.toFixed(2) + "%";
    }, false);
  }
  
  function parseData(valueString, indice){
    let iValue = 0;

    if (indice == 0 || indice == 3 || indice == 4)
    {
        iValue = 1;
    }

    if (valueString === undefined){
        return [0,0];
    }
    valueString = valueString.indexOf('|') !== -1 ? valueString : valueString+'|0';
    let values = valueString.split('|');
    let parsedValues = values.map( value => parseFloat(values[iValue]));

    return([
        isNaN(parsedValues[0]) ? 0 : parsedValues[0],
        isNaN(parsedValues[1]) ? 0 : parsedValues[1]
    ]);
}
  const tableTitleHeight = 24;
  const pieValues: number[] = [];
  let pieSum = 0;

  const pieChartWidth = Math.max(0, (pUiScreenWidth - 40) / 2 - 15 - 75);
  const pieChartHeight = Math.max(0, pChartHeight + 20);
  const centerX = pieChartWidth / 2;
  const centerY = pieChartHeight / 2;
  const rx = pieChartHeight / 2 - tableTitleHeight;
  const ry = pieChartHeight / 2 - tableTitleHeight;

  let startAngle = 0;
  let labelsMap: string[] = [];
  let colorsMap: string[] = [];
  const nLinhas = pRowsHeaders ? pRowsHeaders.length : 0;
  let xElement: any = null;
  let yValue = 0;
  let xValue = 25;
  let headers = pRowsHeaders.length >= qtyMinutes ? pRowsHeaders.slice(0, qtyMinutes) : pRowsHeaders;

  if (nLinhas > 0) {
    const positions: number[] = [];
    let positionTotalEmissoras = 0;

    channels?.enabled.map((column, key) => {
      if (key < qtdEmissoras) {
        if (!column.isTotal) {
          labelsMap.push(column.label);
          colorsMap.push(column.color);
          positions.push(positionTotalEmissoras);
        }

        positionTotalEmissoras += 1;
      }
    });

    let positionTotalValues = 0;

    pRowsColumns.map((column, key) => {
      if (key < qtdEmissoras) {
        if (positions.indexOf(positionTotalValues) >= 0) {
          const values = parseData(column[column.length - 1], u.userPreference.Indice)[0];

          pieSum += values < 100 ? values : 0;
          pieValues.push(values);
        }
        positionTotalValues += 1;
      }
    });

    if (pieSum < 100) {
      const newValue = 100 - pieSum;
      pieValues.push(newValue);
      labelsMap.push("OUTRAS");
      colorsMap.push("#d7d7da");
    }
    
    let strIndice = headers[0][1] + " - " + "SH"
    if (u.userPreference.Indice == 2 || u.userPreference.Indice == 3) {
      strIndice = headers[0][1] + " - " + indice.filter(x => x.Id == u.userPreference.Indice)[0].Desc 
    }

    xElement =
      <svg>
        <text
          x={(pieChartWidth / 2) - 10}
          y={15}
          fill="#000"
          style={{ fontSize: 10 }}>
          {strIndice}
        </text>
      </svg>
  }

  return (

    <div className="PieSvg" style={{
      width: pieChartWidth,
      marginLeft: '10px',
      float: "left"
    }}
    > 
      <div
        id="tooltip-pie"
        data-testid="tooltip-pie"
        style={{
          position: 'fixed',
          height: '12px',
          width: '35px',
          visibility: 'hidden',
          top: '1',
          left: '1',
          marginBottom: '10px',
          marginLeft: '10px',
          color: '#000000',
          textAlign: "center",
          borderRadius: '3px'
        }}
      >
        <text></text>
      </div>
      <svg
        id='pieSVG'
        data-testid='pieSVG'
        width={pieChartWidth}
        height={pieChartHeight}
        style={{
          bottom: 0,
          backgroundColor: '#fff',
          overflow: 'hidden'
        }}
      >
        {pieValues.map((value, index) => {
          if (value === 100) { return } //ignore total-kind values
          const percent = value / 100;
          const backgroundColor: string = colorsMap[index];
          let endAngle = startAngle + percent * (2 * Math.PI);

          if (percent > 0.999) {
            endAngle *= 0.999;
          }
          const x1 = (centerX + rx * Math.cos(startAngle));
          const x2 = (centerX + rx * Math.cos(endAngle));
          const y1 = (centerY + rx * Math.sin(startAngle));
          const y2 = (centerY + rx * Math.sin(endAngle));
          yValue += 22;
          const largeArc = percent > 0.5 ? 1 : 0;
          const piePath = `M${centerX},${centerY} L${x1},${y1} A${rx} ${ry} 0 ${largeArc} 1 ${x2} ${y2} z`;
          startAngle = endAngle;
          return (
            <g key={index}>
              <path
                d={piePath}
                fill={backgroundColor}
                data-testid= 'pie-path-0'
                onMouseEnter={() => enableTooltip('visible', value)}
                onMouseLeave={() => enableTooltip('hidden', value)}
              >
              </path>
              <g>
                <g>
                  {
                    <rect
                      x={xValue}
                      y={yValue}
                      width='20px'
                      height='20px'
                      fill={backgroundColor}>
                    </rect>
                  }
                </g>
                <g>
                  {
                    <text
                      x={xValue + 25}
                      y={yValue + 15}
                      fill="#000"
                      style={{
                        fontWeight: 'bold',
                        fontSize: '10px'
                      }}>
                      {"  " + value.toFixed(2) + "%" + ' - ' + labelsMap[index]}
                    </text>
                  }
                </g>
              </g>
            </g>
          );
        })}
        {xElement}
      </svg>
    </div>
  );
}
